import Button from '@placekit/uikit/components/Button';

import Customers from 'components/Customers';
import Features from 'components/Features';
import HeroAnimation from 'components/HeroAnimation';
import HeroDemos from 'components/HeroDemos';
import Pricing from 'components/Pricing';
import Section from 'components/Section';
import { useT } from 'i18n';

/**
 * Home page body, shared by `/` and `/fr`.
 */
const HomePage = () => {
  const t = useT();

  return (
    <>
      <Section theme="gradient-light" className="relative border-b border-gray-200 overflow-hidden">
        {/* `mb-0`: the absolute HeroAnimation is the last child, Tailwind 4 `space-y-12` would
            add a bottom margin here */}
        <div className="relative z-2 mb-0 text-center">
          <Section.Header
            level={1}
            size="large"
            center={true}
            title={t('home.hero.title')}
            className="sm:max-md:mb-6"
          >
            <p className="mx-auto mt-8 max-w-lg text-lg font-medium bg-linear-to-r from-gray-700 via-gray-500 to-gray-700 bg-clip-text text-transparent">
              {t('home.hero.subtitle')}
            </p>
            <div className="mt-16 flex max-sm:flex-col items-center justify-center gap-4 sm:gap-6">
              <Button
                href="https://app.placekit.io/auth/register"
                label={t('common.cta.getStartedFree')}
                kind="primary"
                size="medium"
              />
              <Button
                href={t.path('/#overview')}
                scroll={false}
                label={t('common.cta.discoverFeatures')}
                kind="neutral"
                size="medium"
                icon="sparkles"
                iconKind="outline"
              />
            </div>
          </Section.Header>
        </div>
        {/* Tailwind 3 `space-y-12` gave this absolute element a 3rem top margin, now in `top-*` */}
        <HeroAnimation className="absolute left-1/2 top-32 sm:top-0 w-[1058px] -translate-x-1/2" />
      </Section>
      {/* Extra bottom padding clears the demo card and its "Try it" hint, which overlap upward. */}
      <Customers className="pb-20 sm:pb-28" />
      <HeroDemos className="bg-accent-500" />
      <Features className="sm:-mt-8 md:-mt-16" />
      <Pricing />
    </>
  );
};

export default HomePage;
